// web/src/store/phone/types.ts —— 对外：PhoneStatus（含 sip.js UA 选项修正副作用）
// 拆自 web/src/store/phone.ts 的同名分区（内容原样搬运）；由 web/src/store/phone.ts 以 export * 聚合，导出面对调用方不变。

import { Invitation, Inviter, Registerer, RegistererState, Session, SessionState, TransportState, UserAgent, UserAgentRegisteredOptionTags } from 'sip.js';

// 去掉 REGISTER 中的 "Supported: outbound"：sip.js 无条件附加该标签（源码注释亦存疑），
// 而 mod_sofia 对 RFC5626 outbound 注册的 .invalid WS 联系地址路由不回既有连接，
// 会导致 ACD originate 坐席时本地 503、INVITE 永远发不出去（已实测复现）。
delete (UserAgentRegisteredOptionTags as Record<string, boolean>).outbound;

export type PhoneStatus =
  | 'idle' // 未配置/未启动
  | 'registering'
  | 'registered' // 空闲可呼叫
  | 'ringing-in'
  | 'ringing-out'
  | 'in-call'
  | 'error';
